module.exports = __webpack_public_path__ + "img/volume_up.3ba37ebc.svg";